import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
import styled from "styled-components";
import axios from "axios";

import { Code } from "react-content-loader";
import { getName } from "../tools/AmbassadorsList";
import AmbStatsTool from "../tools/AmbStatsTool";

export default function AmbStatsPanel(props) {
    const {
        id,
        universityId
    } = props;

    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);

    useEffect(() => {
        setLoading(true);
        axios.get(`/ambassadors/all?stats=yes`).then(d => {
            setUsers(d.data || []);
            setLoading(false);
        });
    }, []);

    if (loading == true && users == undefined || users.length == 0) {
        return (
            <Code />
        );
    }
    let xUsers = (id == undefined) ? users : users.filter(a => a.id == id);
    console.log("AmbStatsPanel: xUsers = ", xUsers);
    if (universityId != undefined){
        xUsers = xUsers.filter(x => x.ambassadorUniversityId == universityId);
    }
    // name: "Глеб Лебедев",
    //     invitedFriendsNumber: 5,
    //     bookingsNumber: 10,
    //     events: ["Мероприятие 1", "Мероприятие 2", "Мероприятие 3"]
    let enhUsers = xUsers.map(x => {
        let { stats = {} } = x;
        let { events = [], refUsers = [], refBookings = [] } = stats;
        return {
            ...x,
            name: getName(x),
            invitedFriendsNumber: refUsers.length,
            bookingsNumber: refBookings.length,
            events: events.map(x => x?.details?.name).filter(x => (x != undefined))
        };
    });


    return (
        <Wrapper>
            <AmbStatsTool
                id={id}
                items={enhUsers}
            />
        </Wrapper>
    );
}

const Wrapper = styled.div`

`;